import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import App from './App';
import { AuthProvider } from './context/AuthContext';  // path may vary

// 1. Import the environment classes or helpers
import { AppEnvironment } from './services/ApiClient';

// -------------------- CONFIGURATION -------------------- //
function getConfiguration() {
    return {
        buildMode: process.env.REACT_APP_ENV,
        baseURL: process.env.REACT_APP_BASE_URL,
    };
}

// 3. Configure environment before rendering
const configuration = getConfiguration();
AppEnvironment.configure(configuration);

console.log ("index js base URL = " + AppEnvironment.config.baseURL)

const domNode = document.getElementById('root');
const root = createRoot(domNode);


root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <App />
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);